// dashbaord
import Default from "../Components/Dashboard/Default";
import Ecommerce from "../Components/Dashboard/Ecommerce";

//widgets
import Chart from "../Components/Widgets/Chart";
import General from "../Components/Widgets/General";





//Masters
import FilterCategoryListing from "../Modules/Masters/filter category List/Filtercategory";
import AddFilterCategory from "../Modules/Masters/filter category List/Add";
import EditFilterCategory from "../Modules/Masters/filter category List/Edit";
import ViewFilterCategory from "../Modules/Masters/filter category List/View";

// import ChargerTypeListing from "../Modules/Masters/Charger Type/ChargerType";
// import ChargerTypeListingAdd from "../Modules/Masters/Charger Type/Add";
// import Connector from "../Modules/Masters/Connector/Connector";
// import AddConnector from "../Modules/Masters/Connector/Add";
import DeletedFilterCategory from "../Modules/Masters/filter category List/DeletedFilterCategory";


//Masters

// import MasterListing from "../Modules/Masters/Master";
// import AddMaster from "../Modules/Masters/Add";
// import EditMaster from "../Modules/Masters/Edit";
// import ViewMaster from "../Modules/Masters/View";

//ImportExcel
  
import ImportExcel from "../Modules/ImportExcel/ImportExcel";
import ViewMailSentUsers from "../Modules/Email/ViewMailSentUsers";
import ExcelUsersLogs from "../Modules/ImportExcel/ExcelLogs"

//charts
// import LineChartApex from "../Modules/charts/charts";

//Product

import ProductList from "../Modules/Product/Product";
import AddProduct from "../Modules/Product/Add";
import EditProduct from "../Modules/Product/Edit";
import ViewProduct from "../Modules/Product/View";
import ComboProduct from "../Modules/Product/ComboProducts";
import AddCombo from "../Modules/Product/ComboAdd";
import ComboEdit from "../Modules/Product/ComboEdit";


//users

import UserListing from "../Modules/Users/Users";
import EditUser from "../Modules/Users/Edit";
import ViewUser from "../Modules/Users/View";
import AddUser from "../Modules/Users/Add";
import DeletedUserRequest from "../Modules/Users/Users_Deleted_Request";
import DeletedUsers from "../Modules/Users/DeletedUsers";

import EmailProcessingLogs from "../Modules/Email/EmailprocessingLogs";

//Corporates

import Corporate from "../Modules/Corporate/Corporate";
import AddCorporate from  "../Modules/Corporate/Add";
import EditCorporate from "../Modules/Corporate/Edit";
import ViewCorporte from "../Modules/Corporate/View";

import Admin from "../Modules/Admin/Admin";
import AddAdmin from "../Modules/Admin/Add";
import EditAdmin from "../Modules/Admin/Edit";
import ViewAdmin from "../Modules/Admin/View";

 import ProfilePage from "../Modules/Settings/ProfilePage";
 import AddPermission from "../Modules/Settings/Add";
 import PermissionLisitng from "../Modules/Settings/PermissionListing";
 import EditPermissions  from "../Modules/Settings/Edit";

 //Order
 import Order from "../Modules/Order/Order";
 import ViewOrder from "../Modules/Order/View";
 import PendingOrders from "../Modules/Order/PendingOrders";
 import PlacedOrder from "../Modules/Order/PlacedOrders";
 import ReturnedOrder from "../Modules/Order/ReturnedOrders";
 import ShippmentOrders from "../Modules/Order/ShippmentOrders";
 import ShippmentLogs from "../Modules/Order/ShippmentLogs";

 //Device
 import Device from "../Modules/Device/Device";
 import DeviceTracking from "../Modules/Device/DeviceTracking";

 //Manual Orders
 import ManualOrders from "../Modules/Manual Orders/ManualOrders";
 import AddManualorder from "../Modules/Manual Orders/Add";
 import OrdersProcessingLogs from "../Modules/Manual Orders/OrderProcessingLogs";
 
  //Company 
  import CompanyList from "../Modules/Company/Company";
  import AddCompany from "../Modules/Company/Add";
  import EditCompany from "../Modules/Company/Edit";
  import CompanyDiscount from "../Modules/Company/Company_discount";
  import CompanyDiscountAdd from "../Modules/Company/Add_discount";

 

export const routes = [

  
  //dashboard
  {
    path: `${process.env.PUBLIC_URL}/dashboard/default`,
    Component: <Default />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`,
    Component: <Ecommerce />,
  },

  // //widgets
  { path: `${process.env.PUBLIC_URL}/widgets/general`, Component: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart`, Component: <Chart /> },

//Masters

{
  path: `/masters/categorylist`,
  Component: <FilterCategoryListing />,
},
{
  path: `/masters/categorylist/:pid`,
  Component: <FilterCategoryListing />,
},
{
  path: `/masters/categorylist/add`,
  Component: <AddFilterCategory />,
},
{
  path: `/masters/categorylist/add/:pid`,
  Component: <AddFilterCategory />,
},
{
  path: `/masters/categorylist/edit/:cid`,
  Component: <EditFilterCategory />,
},
{
  path: `/masters/categorylist/view/:zid`,
  Component: <ViewFilterCategory />,
},


{
  path: `/masters/deletedcategorylist`,
  Component: <DeletedFilterCategory />,
},
  //Corporate
  { path: `/corporates/add-corporate`, Component: <AddCorporate />,},
  { path: `/corporate/list`, Component: <Corporate />,},
  { path: `/corporate/edit-corporate/:cid`, Component: <EditCorporate />,},
  { path: `/corporate/view-corporate/:cid`, Component: <ViewCorporte />,},

//Admin
{ path: `/admin/list`, Component: <Admin/>,},
{ path: `/admin/add`, Component: <AddAdmin/>,},
{ path: `/admin/edit/:cid`, Component: <EditAdmin/>,},
{ path: `/admin/view/:cid`, Component: <ViewAdmin/>,},

///importExcel

{ path: `/importExcel`, Component: <ImportExcel/>,},
{ path: `/view-mail-sent-users/:fid`, Component: <ViewMailSentUsers/>,},
{ path: `/view-excel-users-logs/:fid`, Component: <ExcelUsersLogs/>,},

  // {
  //   path: `/charts`,
  //   Component: <LineChartApex/>,
  // },

  //Products

  { path: `/product-list`, Component: <ProductList/>},
  { path: `/product-add`, Component: <AddProduct/>},
  { path: `/product-edit/:cid`, Component: <EditProduct/>},
  { path: `/product-view/:cid`, Component: <ViewProduct/>},
  { path: `/product/combo-list`, Component: <ComboProduct/>},
  { path: `/comboproduct-edit/:cid`, Component: <ComboEdit/>},
  //
  //
  { path: `/product/add-combo`, Component: <AddCombo/>},
  
  //Users

  {
    path: `/usermanagement/users`,
    Component: <UserListing />,
  },
  {
    path: `/email-processing-logs`,
    Component: <EmailProcessingLogs />,
  },
  //
  {
    path: `/usermanagement/users/:fid`,
    Component: <UserListing />,
  },
  {
    path: `/usermanagements/users/:yid`,
    Component: <UserListing />,
  },

 

  {
    path: `/usermanagement/users/edit/:uid`,
    Component: <EditUser/>,
  },
  {
    path: `/usermanagement/users/view/:uid`,
    Component: <ViewUser/>,
  },
  { path: "/usermanagement/users/requestdeletedusers", Component: <DeletedUserRequest /> },
  { path: "/usermanagement/users/add", Component: <AddUser /> },
  { path: "/usermanagement/users/deletedusers", Component: <DeletedUsers /> },

  //orders

  
  {
    path: `/orders/all-orders-list`,
    Component: <Order/>,
  },
  {
    path: `/orders/pending-orders-list`,
    Component: <PendingOrders/>,
  },
  {
    path: `/orders/placed-orders-list`,
    Component: <PlacedOrder/>,
  },
  {
    path: `/orders/return-orders-list`,
    Component: <ReturnedOrder/>,
  },
  {
    path: `/orders/shippment-orders-list`,
    Component: <ShippmentOrders/>,
  },
  {
    path: `/orders/shippment-logs`,
    Component: <ShippmentLogs/>,
  },
  
  

  { path: "/orders/view-order/:cid", Component: <ViewOrder /> },
   { path : "/profile-page", Component: <ProfilePage/>},
   { path : "/permission-page", Component: <PermissionLisitng/>},
   { path : "/permission-add", Component: <AddPermission/>},
   { path : "/permission-edit/:cid", Component: <EditPermissions/>},
   

   //Device

   { path : "/device", Component: <Device/>},
   { path : "/device-tracking", Component: <DeviceTracking/>},
   
   //manual-orders
   { path : "/manualorder", Component: <ManualOrders/>},
   { path : "/manualorder/add", Component: <AddManualorder/>},
   { path : "/manualorder/order-processing-logs", Component: <OrdersProcessingLogs/>},
   { path : "/manualorder/:aid", Component: <ManualOrders/>},
  //  
  //Company
  { path: `/company-list`, Component: <CompanyList/>},
  { path: `/company-add`, Component: <AddCompany/>},
  { path: `/company-edit/:id`, Component: <EditCompany/>},
  { path: `/company-discount-list`, Component: <CompanyDiscount/>},
  { path: `/company-add-discount`, Component: <CompanyDiscountAdd/>},
];
